export default "__VITE_ASSET__BIOaSKN6__"